import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const ContainerBox = withStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    marginBottom: spacing(4),
  },
}))((props: BoxProps) => <Box {...props} />);

export const IconWrapperBox = withStyles(({ spacing }: Theme) => ({
  root: {
    marginRight: spacing(2),
    paddingTop: spacing(0.5),
  },
}))((props: BoxProps) => <Box {...props} />);

export const Name = withStyles({})((props) => (
  <FsBodySmall component="h4" {...props} />
));

export const Description = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))((props) => <FsBodySmall component="p" {...props} />);
